import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionService } from '../services/session.service';

@Component({
  selector: 'app-dialog-start-text',
  templateUrl: './dialog-start-text.component.html',
  styleUrls: ['./dialog-start-text.component.scss']
})
export class DialogStartTextComponent {
  atWelcome = true;

  constructor(
    public _session: SessionService,
    private dialogRef: MatDialogRef<DialogStartTextComponent>
  ) {}

  changeLanguageVersion(locale: string) {
    this._session.setLocale(locale);
  }

  startModule() {
    this.dialogRef.close(true);
  }
} 